import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-alertsandnotifications',
    templateUrl: './alertsandnotifications.component.html',
    styleUrls: ['./alertsandnotifications.component.scss'],
    standalone: false
})
export class AlertsandnotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
